var site = site || {};
var generic = generic || {};
var Model = Model || {};

/**
  * Singleton data model that handles collecting door inventory data for a single or set of skus.
  * This model can also be used to only call door data if needed.
  * When you pass a sku, or set of skus, with the door query, a door_inventory data object will be included.
  * Also, the rpc method changes from 'locator.doorsandevents' to 'locator.doorsandskustatus' when a sku is passed.
  * On success, the event 'DoorsInventory:query:success' is fired and other panels can listen in on that event.
  * Also available are helper methods that when passed a door id and sku id, can return the inventory object or just let
  *   you know if a sku is in-stock or not.
  * NOTE: Each store has a safety stock number and that safety stock is included with the totals coming from the RPC call.
  * You do not need to factor in the saftey stock when computing if a stock is availble or not.
*/
Model.DoorsInventory = (function() {
  var that = {};

  that.data = null;
  that.zipRegEx = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnpstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1})$/);
  that.nameSpace = 'DoorsInventory:';
  that.classificationGroup = null;
  /**
    * Method used to call the load doors and inventory data query.
    * When a sku, or array of skus, is passed, it will return an inventory data object with the door data.
    * This is done by passing the 'use_header' flag, which tells the backend to get the location data via the akamai header data.
    * The default radius for the doors query is within a 50 mile radius unless an optional radius is passed.
    * The queryFieldss are set within the model using the queryFields array object.
    * You can pass an optional callback function or use the event 'DoorsInventory:query:success' on success to receive results data.
    * Here is an example of the return data object with 'door_inventory'.
    *   "value":{
    *     "driving_directions":"yes",
    *     "longitude":"-117.9073244",
    *     "count":8,
    *     "country_code":"us",
    *     "latitude":"33.6834142",
    *     "doors":[446387,185639,165341,165395,165411,429482,429489,429376],
    *     "door_inventory": { ..Inventory objects by door.. },
    *     "results":{ ..Result door data.. }
    *   }
  */
  that.load = function(args) {

    var that = this;
    var _errors = [];
    var _args = args || {};
    var _zip = _args.zip || null;
    var _radius = _args.radius || 50;
    var _state = _args.state || null;
    var _city = _args.city || null;
    var _region_id = _args.region_id || null;
    var _store_types = _args.inv_store_types ? _args.inv_store_types.split(',') : null;
    var _display = ( _args.display && _args.display != '_' ) ? _args.display : null;
    var _skus = ( typeof _args.skus == 'function' ) ? _args.skus : [_args.skus];
    var _callback = _args.callback || null;
    var _useHeader = _args.useHeader || false;
    var _uom = _args.uom || 'mile';
    var showmsg = "1";
    var showsafety = "1";
    var _classification = _args.inv_store_classification ? _args.inv_store_classification.split(',') : null;
    this.classificationGroup = $('.js-store-types-classification').val();
    var queryArgs = {
      params : [{
        'fields' : that.queryFields,
        'radius' : _radius,
        'display' : _display,
        'region_id' : _region_id,
        //'inv_store_types' : _store_types, 
        'skus' : _skus,
        'inv_store_classification': _classification, // Aveda uses CLASSIFICATION for filter instead of STORE_TYPE
        'uom' : _uom,
      }]
    };

    if (Drupal.settings.common && Drupal.settings.common.enable_uk_zipcode) {
      that.zipRegEx = new RegExp(/^([A-PR-UWYZ](([0-9](([0-9]|[A-HJKSTUW])?)?)|([A-HK-Y][0-9]([0-9]|[ABEHMNPRVWXY])?)) ?[0-9][ABD-HJLNP-UW-Z]{2})$/i);
    }
    if (Drupal.settings.common && Drupal.settings.common.enable_au_zipcode) {
      that.zipRegEx = new RegExp(/^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/);
    }
    if (_zip) {
      // If zip is entered, check for valid zip.
      if ( that.zipRegEx.test(_zip) ) {
        queryArgs.params[0].zip = _zip;
        if (Drupal.settings.common && Drupal.settings.common.enable_postcode_text) {
          if (site.templates && site.templates['product_store_check_layout']) {
            var postCode = site.templates['product_store_check_layout'].data.placeholder_zipcode;
            queryArgs.params[0].zip = postCode + ' ' + _zip;
          }
        }
      } else {
        _errors.push({ key : 'invalid_zip' });
      }
    } else if ( _state && _city ) {
      // If state and city are entered
      queryArgs.params[0].state = _state;
      queryArgs.params[0].city = _city;
    } else if ( _useHeader ) {
      // User header param is set.
      queryArgs.params[0].use_header = 1;
    } else {
      // When all else fails.
      _errors.push({ key : 'enter_zip_or_city_state' });
    }

    // Override to force the location for headers.
    var queryParams = document.location.search;
    var hasTestingOverride = queryParams.match(/OVERRIDE_CITY=(\w*)/);
    if (hasTestingOverride && hasTestingOverride[1] && ( !_zip && !_state && !_city )) {
      queryArgs.params[0].fake_mode = hasTestingOverride[1]; // Param for testing to be removed
      queryArgs.params[0].show_message = 1; //Param for testing to be removed
      queryArgs.params[0].use_header = 1; 
    }

    queryArgs.onSuccess = function( results ) {
      if (results) {
        results.args = queryArgs;
      }

      if (typeof _callback == 'function') {
        _callback(results);
      }
      $(document).trigger(that.nameSpace + 'query:success', results);
    };

    queryArgs.onFailure = function( results ) {
      if (results) {
        results.args = queryArgs;
      }

      if (_callback) {
        _callback(results);
      }
      $(document).trigger(that.nameSpace + 'query:failure', results);
    };

    if ( _errors[0] ) {
      $(document).trigger(that.nameSpace + 'query:failure', {
        errors: _errors
      });
    } else {
      if (Drupal.settings.common.disable_auto_spoofing) {
        args.disable_api ? that.query(queryArgs) : '';
      } else {
        that.query(queryArgs);
      }
    }
  };

  /**
    * Method responsible for making the generic jsonrpc fetch to backend.
    * If skus are passed, the 'locator.doorsandskustatus' method is called.
    * Otherwise, the default method 'locator.doorsandevents' is called instead.
    * The 'locator.doorsandskustatus' method returns a 'door_inventory' with sku info in the door data.
    * The 'locator.doorsandevents' will only return door data.
    * The query also handles an onFailure and onSuccess callback.
    * If successful, it will return the result along with filtering the data and setting the class var data.
  */
  that.query = function(args) {
    var that = this;
    var _args = args || {};
    var method = 'locator.doorsandevents';

    $(document).trigger('controls:showLoadingIcon');

    // Override method with locator.doorsandskusstatus when skus are passed.
    try {
      if (_args.params[0] && _args.params[0].skus) {
        method = 'locator.doorsandskustatus';
      }
    }
    catch(err) {
    }

    generic.jsonrpc.fetch({
      method: method,
      params: _args.params,
      onSuccess: function(r) {
        var result = r.getValue();
        if ( result && _args.onSuccess && typeof _args.onSuccess == 'function' ) {
          result.params = _args.params;
          result.sorted = that.filterResults(result, args);
          result.results = that.updateResults(result);
          that.data = result;
          _args.onSuccess(result);
        }
      },
      onFailure: function (r) {
        if ( _args.onFailure && typeof _args.onFailure == 'function' ) {
          _args.onFailure(r);
        }
      }
    });
  };

  that.updateResults = function( rawResultData ) {
    if (!rawResultData || !rawResultData.results) {
      return null;
    }

    var modResults = $.extend({}, rawResultData.results);
    for (var result in modResults) {
      if (modResults[result] && modResults[result].DISTANCE) {
        var distance = modResults[result].DISTANCE;
        var match = distance.match(/\d*.\d/);
        if ( match ) {
          var shortDist = (match[0] < 1) ? '0' + match[0] : match[0];
          modResults[result].distance_short = shortDist;
        }
      }
    }

    return modResults;
  };

  /**
    * Method responsible for filtering the raw result data by distance and STORE_TYPE.
    * It will iterate through all results and order them by using the door DISTANCE param.
    * First, if a maxDistance is passed, it will filter out doors over that limit.
    * Then it will sort the data by distance by creating a sortedDoorIds array to organize the doors.
`   * Once that list is created, the door data objects will be placed into a sortedResults.
    * If a doorLimit is passed, it will stop adding doors to the sortedResults.
    * It will then filter out doors based on STORE_TYPE if inv_store_types was passed to backend.
    * If inv_store_types was not passed, it will not filter out any doors.
  */
  that.filterResults = function( data, args ) {

    var that = this;

    var _args = args || {};
    var _resultData = $.extend({}, data);

    if (_resultData.maxDistance) { // max distance exists
      var filteredResults = {};
      for (var d in _resultData.results) {
        if (_resultData.results[d].DISTANCE < _resultData.maxDistance) {
          filteredResults[d] = data.results[d];
        }
      }
      _resultData.results = filteredResults;
    }

    // asc. sort by distance
    var sortedResults = [];
    var r = _resultData.results ? _resultData.results : {};
    var sortedDoorIds = _resultData.doors || [];

    function sortByDistance( a, b ) {
      var aDist = (!r[a].DISTANCE || isNaN(r[a].DISTANCE)) ? 0 : parseFloat(r[a].DISTANCE);
      var bDist = (!r[b].DISTANCE || isNaN(r[b].DISTANCE)) ? 0 : parseFloat(r[b].DISTANCE);
    
      if ( aDist > bDist ) { return 1; }
      else if ( aDist < bDist ) { return -1; }
        return 0;
    }

    sortedDoorIds.sort(sortByDistance);

    var params = ( data.params && data.params[0] ) ? data.params[0] : null;
    var doorLimit = params.display || sortedDoorIds.length;
    for (var i=0, len = parseInt(doorLimit); i<len; i++) {
        sortedResults.push(r[sortedDoorIds[i]]);
    }

    // Filter out doors based on inv_store_types passed to the backend if available.
    var inventoryParams = (_args.params && _args.params[0]) ? _args.params[0] : null;
    if (inventoryParams) {
      var storeTypes = inventoryParams.inv_store_classification ? inventoryParams.inv_store_classification : [];
      if (storeTypes.length > 0) {
        if (Drupal.settings.common && Drupal.settings.common.enable_store_order) {
          var storeTypesGroup = that.classificationGroup.split('&');
          var sortedResultsValue = [];
          for (var j = 0; j < storeTypesGroup.length; j++) {
            var storeType = storeTypesGroup[j].indexOf(',') > -1 ? storeTypesGroup[j].split(',') : storeTypesGroup[j];
            for (var k = 0; k < sortedResults.length; k++) {
              if (storeType.indexOf(sortedResults[k].CLASSIFICATION) > -1) {
                sortedResultsValue = sortedResultsValue.concat(sortedResults[k]);
              }
            }
          }
          sortedResults = sortedResultsValue;
        } else {
          sortedResults = sortedResults.filter(function(door) {
            // Check if any storeTypes matches door.STORE_TYPE
            if (door.JDA_STORE_NUMBER != null) {
              return storeTypes.indexOf(door.CLASSIFICATION) > -1;
            }
          });
        }
      }
    };

    return sortedResults;
  };

  /**
    * Helper method used to extract the sku inventory object from the internal data object.
    * You need to pass the doorId and skuId and that will return the inventory object for that sku and door.
    * When calling this method you'll get the current inventory data stored from the latest query.
    * Here is an example of how the door_inventory object looks like.
    *     "429482": {
    *       "skus_onhand":{
    *         "L11R01": {"available_qty":116,"is_available":1,"last_polled_date":"11/6/2015 12:00:00 AM"}
    *       },
    *       "store_code":17504
    *     }
  */
  that.getDoorSkuInventoryData = function(args) {

    var _args = args || {};
    var doorId = _args.doorId ? _args.doorId.toString() : null;
    var skuId = _args.skuId ? _args.skuId.toString() : null;
    var callback = _args.callback;
    var inventoryData  = (that.data && that.data.door_inventory) ? that.data.door_inventory : null;
    var doorInventoryObj = (inventoryData && inventoryData[doorId]) ? inventoryData[doorId]: null;
    if ( !doorInventoryObj || !doorId || !skuId ) {
      return null;
    }

    doorInventoryObj = ( doorInventoryObj && doorInventoryObj.skus_onhand ) ? doorInventoryObj.skus_onhand : null;
    var skuInventory = ( doorInventoryObj && doorInventoryObj[skuId] ) ? doorInventoryObj[skuId] : null;

    return skuInventory;
  };

  /**
    * Helper method to determine if a particular sku is available at a specific door.
    * If door data is available or not with for that sku and door, it will pass a boolean.
    * If data isn't available, it will pass null.
    * It uses the internal method getDoorSkuInventoryData to get the door inventory object.
    * NOTE: Back end determines is_available, is_unavailable and is_call.
  */
  that.isDoorSkuInStock = function( args ) {

    var callback = args.callback;
    var skuInventory = that.getDoorSkuInventoryData(args);

    var inStock = null;
    if ( skuInventory && skuInventory.is_available ) {
      inStock = true;
    } else if ( skuInventory && skuInventory.is_call ) {
      inStock = false;
    } else if ( skuInventory && skuInventory.is_unavailable ) {
      inStock = false;
    }

    if (typeof callback == 'function') {
      callback(inStock);
    } else {
      return inStock;
    }
  };

  /**
    * Helper method to get the last polled date for a particular sku with a specific door.
    * It uses the internal method getDoorSkuInventoryData to get the door inventory object.
    * If the date is available, it will return that date otherwise it will return null;
    * NOTE: Date format is also configurable on the back-end, so try there first before using this method.
  */
  that.getDoorSkuPolledDate = function(args) {

    var skuInventory = that.getDoorSkuInventoryData(args);

    var polledDate = (skuInventory && skuInventory.last_polled_date) ? skuInventory.last_polled_date : null;
    var date = polledDate ? polledDate.match(/([\w\d\/]*)/gi) : [];

    return date[0];
  };

  that.remove = function() {
    var docEvents = $._data( $(document)[0], 'events' );
    for (var evt in docEvents) {
      var match = evt.match('^'+that.nameSpace);
      if ( match ) {
        $(document).unbind(match.input);
      }
    }
  };

  /**
    * Default query fields for the doors and inventory queries.
  */
  that.queryFields = "DOOR_ID, DOORNAME, SUB_HEADING, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY, REGION, COUNTRY, ZIP_OR_POSTAL, PHONE1, STORE_TYPE, LONGITUDE, LATITUDE, JDA_STORE_NUMBER, STORE_TYPE,CLASSIFICATION";

  /**
    * Default query fields for the doors queries only.
  */
  that.queryDoorsFields = "DOOR_ID";

  return that;
}());
